import { UsersService } from "@services/users.service";
import { StateService } from "@uirouter/angularjs";
import * as angular from "angular";

export class IfUserInternal implements angular.IDirective {

    restrict = "A";
    terminal = true;
    priority = 1000;

    link: (scope: angular.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => void;

    constructor(
        private readonly $compile: angular.ICompileService,
        private readonly $state: StateService,
        private readonly usersService: UsersService) {
        IfUserInternal.prototype.link = ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attrs: ng.IAttributes) => {
            if (!usersService.isCurrentUserInternal()) {
                $element.remove();
            } else {
                $element.removeAttr("if-user-internal");
                $compile($element)($scope);
            }
        }
    }

    static factory(): angular.IDirectiveFactory {
        const directive = ($compile: angular.ICompileService, $state: StateService, usersService: UsersService) => new IfUserInternal($compile, $state, usersService);

        directive.$inject = ["$compile", "$state", "usersService"];

        return directive;
    }
}
